var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownArrow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dropdown_arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.46843 4.1653C8.59293 4.16487 8.71594 4.19235 8.82842 4.24571C8.9409 4.29907 9.04 4.37695 9.11843 4.47363L13.1434 9.47363C13.266 9.62274 13.333 9.80978 13.333 10.0028C13.333 10.1958 13.266 10.3829 13.1434 10.532L8.97677 15.532C8.83532 15.7021 8.63206 15.8092 8.4117 15.8295C8.19135 15.8498 7.97195 15.7817 7.80177 15.6403C7.63159 15.4988 7.52457 15.2956 7.50425 15.0752C7.48393 14.8549 7.55199 14.6355 7.69343 14.4653L11.4184 9.99863L7.81843 5.53196C7.71653 5.40964 7.6518 5.26069 7.6319 5.10274C7.612 4.94478 7.63777 4.78443 7.70615 4.64065C7.77453 4.49688 7.88266 4.3757 8.01775 4.29146C8.15284 4.20722 8.30924 4.16344 8.46843 4.1653Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrow2);
export default __webpack_public_path__ + "static/media/dropdown_arrow2.7b6e3d2c8467e57e9cc3eda1a547d608.svg";
export { ForwardRef as ReactComponent };